import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Step } from "../../shared/components/Step/Step";
import { motion } from "framer-motion";
import classes from "./Club.module.scss";

interface ClubStep {
	id: number;
	title: string;
	text: string;
}

export const Club: FC = () => {
	const { t } = useTranslation();
	const steps: ClubStep[] = [
		{
			id: 1,
			title: t("translation.club.title-1"),
			text: t("translation.club.text-1"),
		},
		{
			id: 2,
			title: t("translation.club.title-2"),
			text: t("translation.club.text-2"),
		},
		{
			id: 3,
			title: t("translation.club.title-3"),
			text: t("translation.club.text-3"),
		},
		{
			id: 4,
			title: t("translation.club.title-4"),
			text: t("translation.club.text-4"),
		},
	];
	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<h2 className={classes.title}>{t("translation.club.main-title")}</h2>
				<span className={classes.description}>
					{t("translation.club.description")}
				</span>
				<span className={classes.get}>{t("translation.club.step")}</span>

				<div className={classes.steps}>
					<motion.img
						className={classes.image}
						src="images/club-iphone.png"
						alt=""
						animate={{
							y: [-10, 10, -10],
						}}
						transition={{
							duration: 5,
							repeat: Infinity,
							repeatType: "reverse",
						}}
					/>
					<div className={classes.step}>
						{steps.map(({ id, title, text }) => (
							<Step key={id} title={title} count={id}>
								{text}
							</Step>
						))}
					</div>
				</div>
				<span className={classes.footer}>{t("translation.club.footer")}</span>
			</div>
		</div>
	);
};
